var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPocketSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.277344,
    width: 30,
    height: 31.1392,
    rx: 4,
    transform: "rotate(30.3236 -0.277344 0)",
    fill: "url(#paint0_linear_28055_53645)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28055_53645",
    x1: 14.7227,
    y1: 0,
    x2: 14.7227,
    y2: 31.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBD38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketSquare);
export default __webpack_public_path__ + "static/media/pocket-square.86ad9b0f76cf31d81f6f08932f7867c9.svg";
export { ForwardRef as ReactComponent };